import React, { Component } from 'react'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Icon from '@material-ui/core/Icon'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import { archivePatient, reactivatePatient } from '../api'
import moment from 'moment-timezone'
import { DEFAULT_TIMEZONE } from '../constants'

const styles = {
  table: {
    borderCollapse: 'initial',
  },
  wideColumn: {
    width: 200
  },
  smallColumn: {
    width: 50,
    padding: 0
  },
  row: {
    borderCollapse: 'initial',
   '&:hover td': {
     borderBottom: '1px solid #7FA6B7',
     borderTop: '1px solid #7FA6B7',
     backgroundColor: '#FFFFFF',
   },
   '&:hover td:first-child': {
     borderLeft: '1px solid #7FA6B7',
     borderTopLeftRadius: 3,
     borderBottomLeftRadius: 3
   },
   '&:hover td:last-child': {
     borderRight: '1px solid #7FA6B7',
     borderTopRightRadius: 3,
     borderBottomRightRadius: 3
   },
  },
  largeFont: {
    fontSize: '1.5rem'
  }
}

class PatientsTable extends Component {
  navigate = patient => {
    if (patient.firstName && patient.lastName) {
      this.props.history.push(`/patients/${patient.id}`)
    }
  }

  updateStatus = (id, e) => {
    e.preventDefault()
    e.stopPropagation()
    if (this.props.status === 'Active') {
      archivePatient(id).then(response => this.props.refetch({status: 'Active'}))
    } else {
      reactivatePatient(id).then(response => this.props.refetch({status: 'Inactive'}))
    }
  }

  renderActionButton = patient => {
    return (
      <TableCell onClick={e => this.updateStatus(patient.id, e)}>
        <Icon>{this.props.status === 'Active' ? 'archive' : 'unarchive'}</Icon>
      </TableCell>
    )
  }

  renderNotification = patient => {
    return patient.notifications.some(notification => notification.active)
  }

  render () {
    const { classes, patients } = this.props

    return (
      <Table className={classes.table}>
       <TableHead>
         <TableRow>
           <TableCell className={classes.smallColumn}></TableCell>
           <TableCell>Name</TableCell>
           <TableCell className={classes.wideColumn}>Start Date</TableCell>
           <TableCell>Phone Number</TableCell>
           <TableCell>Treatment Center</TableCell>
           <TableCell className={classes.wideColumn}>Last Entry</TableCell>
           <TableCell>Account Status</TableCell>
           <TableCell>{this.props.status === 'Active' ? 'Deactivate' : 'Reactivate'}</TableCell>
         </TableRow>
       </TableHead>
       <TableBody>
        {patients.map(patient => (
          <TableRow hover key={patient.id} className={classes.row} onClick={e => this.navigate(patient)}>
              <TableCell className={classes.largeFont}> { this.renderNotification(patient) ? '✴' : ''} </TableCell>
              <TableCell> {`${patient.firstName} ${patient.lastName}`} </TableCell>
              <TableCell> {moment.utc(patient.activation_date).tz(DEFAULT_TIMEZONE).format('MMMM DD YYYY')} </TableCell>
              <TableCell> {patient.phoneNumber} </TableCell>
              <TableCell> {patient.treatmentCenter} </TableCell>
              <TableCell> {patient.lastEntry && moment.utc(patient.lastEntry).tz(DEFAULT_TIMEZONE).format('MMMM DD YYYY hh:mm A') } </TableCell>
              <TableCell> {patient.status} </TableCell>
              { this.renderActionButton(patient) }
          </TableRow>
        ))}
       </TableBody>
      </Table>
    )
  }
}

export default withRouter(withStyles(styles)(PatientsTable))



// WEBPACK FOOTER //
// ./src/components/PatientsTable.js